import { render, staticRenderFns } from "./Waarde.vue?vue&type=template&id=56a77a12"
import script from "./Waarde.vue?vue&type=script&lang=js"
export * from "./Waarde.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports